export default __webpack_public_path__ + "static/media/Soleil.8602c203.otf";